import React, {useEffect} from 'react';
import localStrings from "../../localStrings";
import useAuth from "../../hooks/useAuth";
import {DataGridPremium, useGridApiRef, useKeepGroupedColumnsHidden} from "@mui/x-data-grid-premium";
import {ThemeProvider, useTheme} from "@mui/material/styles";
import {dataGridTheme} from "./index";
import { GRID_ROW_GROUPING_SINGLE_GROUPING_FIELD } from '@mui/x-data-grid-premium';

function SummaryGridView({pivotModel, setPivotModel,
                             pivotActive, setPivotActive, displayToolBar = true}) {

    const [statsForDataGrid, setStatsForDataGrid] = React.useState(null);
    const [groupingModel, setGroupingModel] = React.useState([]);
    const [pivotModelLocal, setPivotModelLocal] = React.useState({"rows":[{"field":"staffName","hidden":false}],"columns":[],"values":[{"field":"totalTurnover","aggFunc":"sum","hidden":false}]});
    const [pivotActivelLocal, setPivotActiveLocal] = React.useState(false);
    const theme = useTheme();

    const columns = [
        {
            field: 'staffName',
            headerName: localStrings.staff,
            width: 120,
        },
        {
            field: 'locationName',
            headerName: localStrings.location,
            width: 150,
        },
        {
            field: 'timeSlot',
            headerName: localStrings.timeSlot || "Tranche horaire",
            width: 150,
        },
        {
            field: 'totalTurnover',
            headerName: localStrings.totalWithTax || "CA TTC",
            type: 'number',
            width: 150,
            // valueFormatter: ({ value }) =>
            //     typeof value === 'number' ? `${value.toFixed(2)} €` : '',
        },
        {
            field: 'offeredCount',
            headerName: localStrings.offeredCount || "Offerts",
            type: 'number',
            width: 150,
        },
        {
            field: 'totalDiscount',
            headerName: localStrings.totalDiscount || "Remises (€)",
            type: 'number',
            width: 140,
            // valueFormatter: ({ value }) =>
            //     typeof value === 'number' ? `${value.toFixed(2)} €` : '',
        },
        {
            field: 'totalOrders',
            headerName: localStrings.totalOrders || "Nb commandes",
            type: 'number',
            width: 140,
        },
        {
            field: 'averageTicket',
            headerName: localStrings.averageTicket || "Ticket moyen",
            type: 'number',
            width: 150,
            // valueFormatter: ({ value }) =>
            //     typeof value === 'number' ? `${value.toFixed(2)} €` : '',
        },
        {
            field: 'nbSeats',
            headerName: localStrings.nbSeats || "Couverts",
            type: 'number',
            width: 150,
        },
        {
            field: 'averageSeatTurnover',
            headerName: localStrings.averageSeatTurnover || "CA/Siège",
            type: 'number',
            width: 140,
            // valueFormatter: ({ value }) =>
            //     typeof value === 'number' ? `${value.toFixed(2)} €` : '',
        },
        {
            field: 'totalDuration',
            headerName: localStrings.totalDuration || "Durée totale",
            type: 'number',
            width: 140,
            // valueFormatter: ({ value }) =>
            //     typeof value === 'number' ? `${value.toFixed(0)} min` : '',
        },
        {
            field: 'averageDuration',
            headerName: localStrings.averageDuration || "Durée moy.",
            type: 'number',
            width: 180,
            // valueFormatter: ({ value }) =>
            //     typeof value === 'number' ? `${value.toFixed(0)} min` : '',
        },
        {
            field: 'averageSeatTicket',
            headerName: localStrings.averageSeatTicket || "Ticket/Siège",
            type: 'number',
            width: 200,
            // valueFormatter: ({ value }) =>
            //     typeof value === 'number' ? `${value.toFixed(2)} €` : '',
        },
    ];



    const { filter, mergedSumUpDayWithNames, loadingData} = useAuth()

    // function getTitle() {
    //     if (orders && orders.length > 0) {
    //         return localStrings.formatString(localStrings.accountingDetail,
    //             moment(orders[0].start_time).format("llll"),
    //             moment(orders[orders.length - 1].end_time).format("llll"),
    //         );
    //     }
    //     return localStrings.accounting;
    // }

    function flattenStatsForDataGrid(stats) {
        const rows = [];
        let rowIndex = 1;

        for (const [staffId, staffData] of Object.entries(stats.detailbyStaff || {})) {
            const staffName = staffId; // Tu peux remplacer par le vrai nom si disponible

            for (const [locationId, locationData] of Object.entries(staffData.locations || {})) {
                const locationName = locationId; // Tu peux remplacer par le vrai nom si disponible

                const timeSlots = locationData?.products?.timeSlot || {};
                for (const [timeSlot, slotData] of Object.entries(timeSlots)) {
                    const row = {
                        id: `${staffId}_${locationId}_${timeSlot}_${rowIndex}`, // ID unique combiné
                        staffId,
                        staffName,
                        locationId,
                        locationName,
                        timeSlot,
                        totalTurnover: slotData.totalTurnover ?? 0,
                        offeredCount: slotData.offeredCount ?? 0,
                        totalDiscount: slotData.totalDiscount ?? 0,
                        totalOrders: slotData.totalOrders ?? 0,
                        averageTicket: slotData.averageTicket ?? 0,
                        nbSeats: slotData.nbSeats ?? 0,
                        averageSeatTurnover: slotData.averageSeatTurnover ?? 0,
                        totalDuration: slotData.totalDuration ?? 0,
                        averageDuration: slotData.averageDuration ?? 0,
                        averageSeatTicket: slotData.averageSeatTicket ?? 0,
                    };

                    rows.push(row);
                    rowIndex++;
                }
            }
        }

        return rows;
    }



    useEffect(() => {
            if (mergedSumUpDayWithNames) {
                setStatsForDataGrid(flattenStatsForDataGrid(mergedSumUpDayWithNames));
            }
            else {
                setStatsForDataGrid([]);
            }
            // let ordersFormatted = (orders || []).map(order => {
            //     return {
            //         ...order,
            //         nb_seats: parseFloat(order.nb_seats || 0),
            //         totalWithTaxRaw: parseFloat(order.totalWithTaxRaw || 0),
            //         taxesRaw: parseFloat(order.taxesRaw || 0),
            //         start_time: moment(order.start_time).format('YYYY-MM-DD HH:mm:ss'),
            //         end_time: moment(order.end_time).format('YYYY-MM-DD HH:mm:ss'),
            //         staff_name: order.staff?.staff_name || '',
            //         table_name: order.table?.table_name || '',
            //         payment_types: (order.payments || []).map(pay => pay.name).sort().join(', '),
            //         location: order.location?.location_name || '',
            //         productSalesCount: (order.items || []).length,
            //         productOptionsCount: (order.items || [])
            //             .reduce((acc, item) => {
            //                 return acc + (item.options || []).length;
            //             }, 0)
            //     }
            // })
            // setFormattedOrders(ordersFormatted);

        },
        [mergedSumUpDayWithNames, filter]);

    function generateInitialStateFromStructuredModel(structuredModel) {
        const safeArray = (v) => Array.isArray(v) ? v : [];

        const rows = safeArray(structuredModel?.rows);
        const values = safeArray(structuredModel?.values);

        // Extraire les champs pour le groupement (row grouping)
        const groupingModel = rows
            .filter(row => row?.field && !row.hidden)
            .map(row => row.field);

        // Extraire les agrégations visibles
        const aggregationModel = {};
        values.forEach(val => {
            if (val?.field && val?.aggFunc && !val.hidden) {
                aggregationModel[val.field] = val.aggFunc;
            }
        });

        // Tri par défaut si grouping actif
        const sortingModel = groupingModel.length > 0 ? [{
            field: GRID_ROW_GROUPING_SINGLE_GROUPING_FIELD,
            sort: 'asc'
        }] : [];

        return {
            rowGrouping: {
                model: groupingModel
            },
            sorting: {
                sortModel: sortingModel
            },
            aggregation: {
                model: aggregationModel
            }
        };
    }
    const apiRef = useGridApiRef();

    const initialState = useKeepGroupedColumnsHidden({
        apiRef,
        initialState: {
            "rowGrouping": {
                "model": [
                    "staffName"
                ]
            },
            "sorting": {
                "sortModel": [
                    {
                        "field": "__row_group_by_columns_group__",
                        "sort": "asc"
                    }
                ]
            },
            "aggregation": {
                "model": {
                    "averageDuration": "sum",
                    "totalTurnover": "sum"
                }
            }
        }
    });

    return (
        <div>
            {/*{orders && orders.length > 0 &&*/}
            {/*    <Box*/}
            {/*        sx={{*/}
            {/*            display: 'flex',*/}
            {/*            flexDirection: 'row',*/}
            {/*            alignItems: 'flex-end',*/}
            {/*            gap: 2, // espace horizontal entre chaque bloc*/}
            {/*        }}*/}
            {/*    >*/}
            {/*        <Box>*/}
            {/*            <Typography variant="body1" color="primary.main">*/}
            {/*                {moment(orders[0].start_time).format("dddd, DD MMMM YYYY")}*/}
            {/*            </Typography>*/}
            {/*        </Box>*/}
            {/*        <Box>*/}
            {/*            <Typography variant="subtitle2" color="secondary.main">*/}
            {/*                {moment(orders[0].start_time).format("HH:mm:ss")}*/}
            {/*            </Typography>*/}
            {/*        </Box>*/}
            {/*        <Box>*/}
            {/*            <Typography variant="body1" color="text.secondary">*/}
            {/*                /*/}
            {/*            </Typography>*/}
            {/*        </Box>*/}
            {/*        <Box>*/}
            {/*            <Typography variant="body1" color="primary.main">*/}
            {/*                {moment(orders[orders.length - 1].end_time).format("dddd, DD MMMM YYYY")}*/}
            {/*            </Typography>*/}
            {/*        </Box>*/}
            {/*        <Box>*/}
            {/*            <Typography variant="subtitle2" color="secondary.main">*/}
            {/*                {moment(orders[orders.length - 1].end_time).format("HH:mm:ss")}*/}
            {/*            </Typography>*/}
            {/*        </Box>*/}
            {/*    </Box>*/}

            {/*}*/}


            {statsForDataGrid &&
                <div style={{height: 'calc(100vh - 160px)', width: '100%'}}>
                    {/*<p>{JSON.stringify(pivotModel || {})}</p>*/}
                    {/*<p>{JSON.stringify(groupingModel || {})}</p>*/}
                    {/*<p>{JSON.stringify(generateInitialStateFromStructuredModel(pivotModel)  || {})}</p>*/}


                    <ThemeProvider theme={dataGridTheme}>
                        {/*<p>{JSON.stringify(statsForDataGrid )}</p>*/}
                        <DataGridPremium
                            onPivotModelChange={(newModel) => {
                                setPivotModel ? setPivotModel(newModel) : setPivotModelLocal(newModel);
                                console.log("Serialized pivot:", JSON.stringify(newModel));
                            }}
                            onRowGroupingModelChange={(newModel) => {
                                setGroupingModel(newModel);
                                console.log("Serialized grouping:", JSON.stringify(newModel));
                            }}
                            pivotActive={pivotActive || pivotActivelLocal}
                            onPivotActiveChange={(newValue) => {
                                setPivotModel ? setPivotActive(newValue) : setPivotActiveLocal(newValue);
                                console.log("Pivot active:", newValue);
                            }}
                            rowGroupingModel={groupingModel}
                            pivotModel={pivotModel || pivotModelLocal}

                            // initialState={initialState}
                            rows={statsForDataGrid || []}
                            columns={columns}
                            showToolbar={displayToolBar}
                            getDetailPanelHeight={() => 'auto'}
                            loading={loadingData}
                            slotProps={{
                                toolbar: {
                                    showQuickFilter: false,
                                },
                            }}
                            sx={{
                                margin: 'none',
                                '& .MuiDataGrid-row': {
                                    borderBottom: '1px solid rgba(224, 224, 224, 1)',
                                },
                                '& .MuiDataGrid-toolbarContainer': {
                                    borderBottom: '1px solid rgba(224, 224, 224, 1)',
                                    paddingBottom: 1,
                                },
                                '& .MuiDataGrid-columnHeaderTitle': {
                                    fontWeight: 'bold',
                                },
                            }}
                        />
                    </ThemeProvider>
                </div>
            }
        </div>
    )
}

export default SummaryGridView